import vi from "antd/es/date-picker/locale/vi_VN";
import en from "antd/es/date-picker/locale/en_US";

const viCustom: typeof vi = {
  ...vi,
  lang: {
    ...vi.lang,
    dateSelect: "Chọn ngày",
    placeholder: "Chọn ngày",
    timeSelect: "Chọn giờ",
    ok: "Xác nhận",
  },
  timePickerLocale: {
    placeholder: "Chọn giờ",
  },
};

/**
 * Returns DatePicker locale dynamically based on active language.
 */
export const getPickerLocale = (): typeof vi => {
  const lang = typeof window !== "undefined" ? localStorage.getItem("mooc_language") : "vi";
  return lang === "en" ? en : viCustom;
};

/**
 * Dynamic Proxy so existing `<DatePicker locale={viLocale} />` automatically
 * adapts between English and Vietnamese based on current user selection.
 */
export const viLocale: typeof vi = new Proxy(viCustom, {
  get(target, prop, receiver) {
    const current = getPickerLocale();
    return Reflect.get(current, prop, receiver);
  },
});

export const options = [
  { label: "Ngày", id: 1 },
  { label: "Tuần", id: 2 },
  { label: "Tháng", id: 3 },
];

